export default __webpack_public_path__ + "d2279a28ea275581a23382f5daed5520.png";